<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section>
    <h3 class="text-center">Create Wing</h3>

    <!-- form -->
    <validation-observer ref="wingValidation">
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent
      >
        <validation-provider
          #default="{ errors }" name="Name" rules="required">
          <label>Name</label>
          <b-form-input
            v-model="wing.name" class="mb-1" cy="wing-name"
            :state="errors.length > 0 ? false:null"
            placeholder="Enter name"
          />
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider
          #default="{ errors }" name="Terminal Count" rules="required">
          <label>Terminal Count</label>
          <b-form-input
            v-model.number="wing.terminal_stock" class="mb-1" cy="wing-stock"
            type="number"
            :state="errors.length > 0 ? false:null"
            placeholder="Enter stock"
          />
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer"></div>
          <b-button class="mr-1" @click="close">Close</b-button>
          <b-button variant="success" @click="validationForm">Create Wing</b-button>
        </section>
      </b-form>
    </validation-observer>
  </section>
</template>
<!--eslint-enable-->

<script>
import WingService from '@/services/WingService';
import {mapState} from 'vuex';
import {ERROR_CODES} from '@/util/errorCodes';

export default {
  components: {},
  props: {},
  data() {
    return {
      wing: {
        name: '',
        terminal_stock: 10,
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
  },
  mounted() {},
  methods: {
    validationForm() {
      this.$refs.wingValidation.validate()
        .then(success => {
          if (success) {
            this.addWing();
          }
        })
    },
    addWing() {
      WingService.createWing(this.wing).then(() => {
        this.$toast.success(`Wing ${this.wing.name} successfully created`, {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.close();
      }).catch(err => {
        let msg = 'Something went wrong creating the wing, please refresh the page and try again';

        if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.WINGS.STOCK_EXCEEDS_PRISONS_TERMINAL_COUNT) {
          msg = `Error setting stock of wing ${this.wing.name} as it would exceed the ${this.$options.filters.term('prison')}s terminal count.`;
        }

        this.$toast.error(msg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    close() {
      this.$emit('close', true);
    }
  },
};
</script>
